module.exports = __webpack_public_path__ + "img/l2.532ef61c.png";